/**
 * project level public dashboards
 * https://mixpanel.com/api/app/projects/${projectId}/public-dashboards
 *
 */
import {apiClient} from 'common/util/api-client';
import {FetchOptions} from 'common/util/shared-client';

import {
  PublicDashboardEndpointPath,
  PublicDashboardMetadataApiResponse,
  PublicDashboardMetadataPatchOptions,
} from './project-settings-client-types';

class ProjectSettingsClient {
  buildPublicDashboardEndpoint(endpointName: PublicDashboardEndpointPath, projectId: number) {
    return `/api/app/projects/${projectId}/public-dashboards/${endpointName}`;
  }

  async getPublicDashboardMetadata(
    projectId: number,
    fetchOptions: FetchOptions = {},
  ): Promise<PublicDashboardMetadataApiResponse> {
    return apiClient.get<PublicDashboardMetadataApiResponse>(
      this.buildPublicDashboardEndpoint(PublicDashboardEndpointPath.Metadata, projectId),
      fetchOptions,
    );
  }

  async patchPublicDashboardMetadata(
    projectId: number,
    data: PublicDashboardMetadataPatchOptions,
    fetchOptions: FetchOptions = {},
  ): Promise<PublicDashboardMetadataApiResponse> {
    return apiClient.patch<PublicDashboardMetadataApiResponse>(
      this.buildPublicDashboardEndpoint(PublicDashboardEndpointPath.Metadata, projectId),
      data,
      fetchOptions,
    );
  }
}

export const projectSettingsClient = new ProjectSettingsClient();
